import { connect } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { WithThreadId } from '../../../../types';
import { getThreadOriginalSender } from '../../../../selectors/ducksThreads';
import { IntegrationProfileAvatarProps } from './IntegrationProfileAvatar';

type StateProps = Pick<IntegrationProfileAvatarProps, 'originalSender'>;

export default connect<StateProps, {}, WithThreadId, ApplicationState>((state, { threadId }) => ({
    originalSender: getThreadOriginalSender(state, { id: threadId }),
}));
